var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AlertTitle } from '@mui/material';
import { CheckCircle, Info, Warning, WarningCircle } from 'phosphor-react';
import * as Styled from './Alert.styles';
export const Alert = (_a) => {
    var { title } = _a, props = __rest(_a, ["title"]);
    return (React.createElement(Styled.Wrapper, Object.assign({}, props, { icon: React.createElement(React.Fragment, null,
            props.severity === 'error' && React.createElement(WarningCircle, null),
            props.severity === 'info' && React.createElement(Info, null),
            props.severity === 'success' && React.createElement(CheckCircle, null),
            props.severity === 'warning' && React.createElement(Warning, null)) }),
        title && React.createElement(AlertTitle, null, title),
        props.children));
};
